import { AfterViewChecked, AfterContentInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/shared/service/auth.service';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent implements OnInit, AfterContentInit, AfterViewChecked {

  @ViewChild('logo') logo: ElementRef;
  @ViewChild('rightSideLogoDummy') rightSideLogoDummy: ElementRef;

  logoImageUrl: string;
  userTypeText: string;
  currentUserName: string;
  companyWebsite: string;
  clientHeader: string;
  showActions: boolean;
  constructor(private authService: AuthService) { }

  get IsUserLoggedIn() {
    return this.authService.AccessToken;
  }

  ngOnInit() {
    this.logoImageUrl = this.authService.clientLogoUrl;
    this.showActions = sessionStorage.getItem('ProxyOnlyFlag') !== 'Y';
    this.updateUserInfo();
  }

  ngAfterContentInit() {
    this.authService.routeChangedSubj.subscribe((posts) => {
      this.userTypeText = this.authService.getUserTypeBasedText();
    });
    this.authService.accessTokenRemovedSubj.subscribe((posts) => {
      this.updateUserInfo();
    });
    this.authService.clientConfigLoaded.subscribe((posts) => {
      this.logoImageUrl = this.authService.clientLogoUrl;
      this.clientHeader = this.authService.clientHeader;
      this.companyWebsite = this.authService.wpCompanyWebsite;
      if (!this.companyWebsite?.toLowerCase().startsWith('http://') && !this.companyWebsite?.toLowerCase().startsWith('https://')) {
        this.companyWebsite = 'https://' + this.companyWebsite;
      }
    });
  }

  ngAfterViewChecked() {
    this.updateLogoDummy();
  }

  private updateLogoDummy() {
   this.rightSideLogoDummy.nativeElement.style.width = !this.IsUserLoggedIn ? this.logo.nativeElement.offsetWidth + 'px' : 0;
  }

  private updateUserInfo() {
    this.currentUserName = (this.authService.originalUser || this.authService).UserName;
  }
}
